import { render } from "./help.vue?vue&type=template&id=04fbfbb0"
const script = {}

import exportComponent from "/Users/helgeohltpng/Developer/js/triton/hoTriton/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__